import Selector from './department-selector.vue';
export default Selector;
